import { getKeys } from './getKeys'

export const selfServeTranslations = {
  YOU_WILL_RECEIVE:
    'You will receive app notifications and see recorded incidents in this box for 24 hours.',
  SEE_WHAT:
    'See what is due today, in the future and the percentage of {{variable}} completed.',
  VIEW_EXAMPLE: 'View an example {{variable}}',
  START_STEP_TITLE: `Simply click 'Start' to embark on your exploration!`,
  START_STEP_DESC:
    'You`ve arrived at the dashboard, where you can see what`s happening in your care service at a glance.',
  CARE_PLAN_STEP_TITLE:
    'Select a {{variable}} thats overdue and set a review date',
  CARE_PLAN_STEP_DESC:
    'Stay on top of reviews and effortlessly manage risk assessments, documents, and consent signatures all from one place.',
  RISK_ASSESSMENT_STEP_TITLE:
    'Visit the Risk Assessments tab to create an assessment of your choice',
  RISK_ASSESSMENT_STEP_DESC:
    'Save valuable time with our extensive library of 40 Risk Assessment templates. Effortlessly identify and update changing risk scores once populated.',
  LOGS_STEP_TITLE: `Navigate to the logs page and hit the 'Add Log' or use our shortcut below`,
  LOGS_ASSESSMENT_STEP_DESC:
    'Stay organised and in control with Our Daily Logs. Track your tasks, activities, and responsibilities effortlessly.',
  APP_STEP_TITLE: 'Take a moment to try out our app',
  APP_STEP_DESC: `Effortlessly capture care records on the go, it's the simplest way to document your care.`,
  SCAN_TO_DOWNLOAD: 'Scan the code to download',
  STEP_X_OF_X: 'Step {{from}} of {{to}}',
  LINK_TO_APP: 'Link to App',
  GREAT_JOB_STEP_TITLE:
    'Great job! You`ve completed your introduction to the Care Office',
  GREAT_JOB_STEP_DESC:
    'Remember, if you need any help along the way, don`t hesitate to explore our ',
  HELP_CENTRE: 'Help Centre',
  COMPLETED: 'Completed!',
  START: 'Start',
  GO_TO: 'Go to {{variable}}',
  RISK_ASSESMENTS: 'Risk Assessments',
  CREATE_A_LOG: 'Create a Log',
  CLOSE: 'Close',
  DISCOVER_WHAT:
    'Discover what the Care Office can do for you, free of charge.',
  START_PRO_TRIAL: 'Start Pro Trial',
  INTERESTED_IN: 'Interested in Pro? Book a 1-2-1 call',
  CONTINUE_WITH: 'Continue with starter plan',
  START_SET_UP: 'Start Set Up',
  SET_YOUR_PREFFERED: 'Set your preferred terms ',
  INVITE_TEAM: 'Invite a Team Member',
  INVITE_TEAM_DESC:
    'Give a senior member of your team access to the account, so they can explore the Care Office. The team member will receive a link to help them get started.',
  NAME_EMAIL: 'Name and Email',
  SEND_INVITE: 'Send Invite',
  CONTINUE_WITHOUT: 'Continue without inviting a Team member',
  SET_A_PIN: 'Choose a pin',
  YOUR_SECURE_CODE: 'Secure your app with a PIN for enhanced security.',
  INVITE_AND_START: 'Invite and Start',
  NEXT: 'Next',
  MAKE_SELECTION: 'Make a selection before proceeding',
  NAME_AND_EMAIL: 'Name and Email',
  FINISH: 'Finish',
  PLEASE_FILL: 'Please fill out all fields before proceeding',
  BY_CHANGING:
    'By changing a term, it will change everywhere it is mentioned in the Care Office and App.',
  GO_TO_HOMEDASH: 'Go to Home Dash',
  VIEW_ALL_ARTICLES: 'View all Help Articles',
  NEED_HELP: `Need help? We've got your back...`,
  DIVE_IN: 'Dive in and watch our video guide for a smooth start.',
  GET_FIRST_HAND:
    'Get first hand knowledge on our new features and how they work.',
  BILLING_INFORMATION: 'Billing Information',
  REVIEW_MANAGE: 'Effortlessly review and manage your billing details.',
  ITS_READING: `Is it reading material you're looking for? We've got you covered!`,
  GETTING_STARTED: 'Getting Started',
  VIEW_OUR: 'View our Webinars',
  SHARE_YOUR: 'Share your Feedback',
  TELL_US: 'Find out more about upcoming features and updates.',
  BOOK_DEMO: 'Book a demo',
  GET_CLOSER: 'Get a closer look; book a demo and you can get a guided tour.',
  BILLING: 'Billing information',
  REVIEW: 'Effortlessly review and manage your billing details.',
  FAQS: 'FAQs',
  BROWSE: 'Browse through our FAQs to find quick solutions.',
  IS_IT: `Is it reading material you're looking for? We've got you covered!`,
  SUPPORT_INDEX: 'Support Index',
  LINK_GETTING: '1. Getting started',
  LINK_CO: '2. The Care Office',
  LINK_CA: '3. The Carer App',
  LINK_PRO: '4. The Pro Plan',
  LINK_OUTSTANDING: '5. The Outstanding Plan',
  LINK_MEDICATION: '6. Medication administration (eMAR)',
  LINK_FAMILY: '7. Family App',
  LINK_KEEP: '8. Keep your service`s data secure',
  LINK_CORONA: '9. Coronavirus resources',
  LINK_SUPPORT: '10. Support',
  LINK_VIEW_ALL: 'View all articles',
  DOWNLOAD_MORE: 'Download some more Information',
  GOING: 'Going Digital Guide.pdf',
  IMPACT: 'Impact of Digital Systems.pdf',
  CONNECT_WITH: 'Connect with us',
  EMAR_WALK: 'eMAR Walkthrough',
  EMAR_WALK_DESC:
    'Take a look at how our medication tools work on the carer app',
  PRO_FEATURE: 'Pro Feature'
}

export const selfServeConstants = getKeys(selfServeTranslations)
